<template>
  <div>
    <list
      row-key="OrderProductId"
      ref="list"
      unit="布产单进度表"
      :isNotSearch="isNotSearch"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.saOrderProductProgressList"
      :query-before="queryBefore"
      :reset-data-func="resetDataFunc"
      @expand-change="expandChange"
      resetCustomQuary
      @resetQuery="resetQuery"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="布产单号" label-width="120px">
          <el-input v-model="params.OrderProductNo" placeholder="请输入布产单号" clearable />
        </el-form-item>
        <el-form-item label="存货名称" label-width="120px">
          <el-input v-model="params.ProductName" placeholder="请输入存货名称" clearable />
        </el-form-item>
        <el-form-item label="展示类型" label-width="120px" required>
          <el-select v-model="params.ShowType" placeholder="请选择展示类型" clearable>
            <el-option label="按bom级次" :value="0"></el-option>
            <el-option label="按加工阶段" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完工日期" label-width="120px">
          <el-date-picker v-model="OrderDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择指定日期" @change="changeOrderDate" clearable />
        </el-form-item>

        <el-form-item label="完工日期范围" label-width="120px">
          <el-select v-model="mode" v-if="mode !== 3" @change="changeMode">
            <el-option label="近三天" :value="1" />
            <el-option label="近七天" :value="2" />
            <el-option label="自定义" :value="3" />
          </el-select>
          <range-picker
            v-else
            ref="picker"
            @change="
              x => {
                params.FinishDateStart = x.Start
                params.FinishDateEnd = x.End
              }
            "
            style="width: 180px !important"
          >
          </range-picker>
        </el-form-item>

        <el-form-item label="状态" label-width="120px">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="布产待审" :value="0"></el-option>
            <el-option label="工单待审" :value="1"></el-option>
            <el-option v-show="!quickProcess" label="未排产" :value="2"></el-option>
            <el-option v-show="!quickProcess" label="已排产" :value="3"></el-option>
            <el-option v-show="!quickProcess" label="报工中" :value="4"></el-option>
            <el-option label="完工" :value="5"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-tabs v-model="scope.row.tabsView" type="card">
              <el-tab-pane label="按图形" name="tabsView1">
                <div class="flex scroll" style="max-height: 600px">
                  <div class="boxwitdh shrink widthx" v-for="(item, index) in scope.row.imageData" :key="index">
                    <div class="textcenter height border" :style="item.bgStyle" style="position: relative">
                      {{ item.levelName }}

                      <span style="position: absolute; right: 5px; top: -2px; font-size: 24px" v-if="index < scope.row.imageData.length - 1">→</span>
                    </div>
                    <div class="flex border center position-relative" style="height: 40px">
                      <div v-for="item3 in 10" :key="item3" class="border bgColor" style="height: 30px; width: 40px">
                        <div
                          class="height100"
                          :class="item3 <= item.headerData.sumTenthsNumber === true ? 'width40 borderright' : 'width0'"
                          :style="[item.headerData.bgStyle, item.headerData.sumTenthsNumber && item3 === item.headerData.sumTenthsNumber + 1 ? item.headerData.sumSingleDigitNumberWidth : '']"
                        ></div>
                      </div>
                      <div style="position: absolute; left: 250px; width: 40px; top: 2.52px; height: 30px; text-align: center; line-height: 30px">
                        {{ item.headerData.sumfinishRate }}
                      </div>
                    </div>
                    <div class="border flex widthx" v-for="(item1, j) in item.data" :key="'_' + j">
                      <el-tooltip class="item" effect="dark" :content="item1.ProductName" placement="top-start">
                        <div class="shrink width100px borderright text-over" style="padding: 5px">
                          {{ item1.ProductName }}
                        </div>
                      </el-tooltip>
                      <div class="flex1 center">
                        <!-- <div class=" height40" :style="[item1.bgStyle, item1.finishRateWidth]" /> -->
                        <div class="height40 flex align-center position-relative">
                          <div class="smbox ml border bgColor" v-for="item2 in 10" :key="item2">
                            <div
                              class="height100"
                              :class="item2 <= item1.tenthsNumber === true ? 'width30 borderright' : 'width0'"
                              :style="[item1.bgStyle, item1.tenthsNumber && item2 === item1.tenthsNumber + 1 ? item1.singleDigitNumberWidth : '']"
                            ></div>
                          </div>
                          <div class="position-text">{{ item1.finishRate }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="按列表" name="tabsView2">
                <el-table key="table1" :data="scope.row.listData" max-height="600">
                  <el-table-column type="index" label="序号" min-width="55" align="left" />
                  <el-table-column v-if="params.ShowType === 0" key="column1" prop="Level" label="层次" min-width="120px" align="left" />
                  <el-table-column v-if="params.ShowType === 1" key="column2" prop="Stage" label="阶段" min-width="120px" align="left" />
                  <el-table-column v-if="params.ShowType === 0" key="column2" prop="Stage" label="阶段" min-width="100px" align="left" />
                  <el-table-column prop="WorkDocNo" label="工单号" min-width="120px" align="left" />
                  <el-table-column prop="ProductName" label="存货名称" min-width="120px" align="left" />
                  <el-table-column prop="Quantity" label="布产数量" min-width="120px" align="right" />
                  <el-table-column prop="StockInQuantity" label="入库数" min-width="120px" align="right">
                    <template slot-scope="{ row }">
                      <el-link type="primary" @click="toPage(row)">{{ row.StockInQuantity }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column prop="UnStockInQuantity" label="未入库数" min-width="120px" align="right" />
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column prop="FinishDate" label="完工日期" min-width="120px" align="left">
          <template slot-scope="{ row }">
            {{ $commonJs.toDateString(row.FinishDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="OrderProductNo" label="布产单号" min-width="120px" align="left" />
        <el-table-column prop="ProductName" label="存货名称" min-width="120px" align="left" />
        <el-table-column prop="ClothQuantity" label="布产数量" min-width="120px" align="right" />
        <el-table-column prop="ReportQuantity" label="已生产数量" min-width="120px" align="right" />
        <el-table-column prop="StockInQuantity" label="入库数" min-width="120px" align="right" />
        <el-table-column prop="UnStockInQuantity" label="未入库数" min-width="120px" align="right" />
        <el-table-column prop="Status" label="状态" min-width="80px" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.Status === 0">布产待审</span>
            <span v-if="row.Status === 1">工单待审</span>
            <span v-if="row.Status === 2">未排产</span>
            <span v-if="row.Status === 3">已排产</span>
            <span v-if="row.Status === 4">报工中</span>
            <span v-if="row.Status === 5">完工</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/list'
import list from '@/components/common/list'

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false
    },
    showType: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    let quickProcess = localStorage.getItem('SET_QuickProcess')
    if (quickProcess === 'true') {
      this.quickProcess = true
    } else {
      this.quickProcess = false
    }
    this.init()
  },
  data() {
    return {
      api: require('@/api/sa/saOrder').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      quickProcess: null,

      params: {
        OrderProductNo: '',
        ProductName: '',
        ShowType: null,
        FinishDateStart: this.$commonJs.getToday(),
        FinishDateEnd: this.$commonJs.getToday(),
        Status: null
      },
      isNotSearch: false,
      OrderDate: this.$commonJs.getToday(),
      mode: null,
      machiningStageList: []
    }
  },
  methods: {
    async toPage(row) {
      let params = {}
      let res = null
      if (row.ProductionType == 0) {
        res = await this.sourceTypeApi.info('生产入库单')
      } else {
        res = await this.sourceTypeApi.info('委外入库单')
      }

      params.InType = res.SourceTypeId
      params.WorkDocNo = row.WorkDocNo

      this.$router.push({ name: 'productionshipping', params: params })
    },
    init() {
      this.machiningStageApi.list({}).then(res => {
        this.machiningStageList = res.Data
      })
    },
    numToText(i) {
      // 数值转文本
      let text = ''
      switch (i) {
        case 1:
          text = '一'
          break
        case 2:
          text = '二'
          break
        case 3:
          text = '三'
          break
        case 4:
          text = '四'
          break
        case 5:
          text = '五'
          break
        case 6:
          text = '六'
          break
        case 7:
          text = '七'
          break
        case 8:
          text = '八'
          break
        case 9:
          text = '九'
          break
      }

      return '第' + text + '层'
    },
    queryBefore() {
      console.log('this.params', this.params)
      // 展示类型必填
      if (this.params.ShowType == null) {
        this.$message.error('请选择展示类型')
        return false
      }

      if (this.params.OrderProductNo === '' && this.params.ProductName === '' && this.OrderDate === '') {
        this.$message.error('布产单号，存货名称，指定日期至少要选择一项')
        return false
      }

      return true
    },
    resetQuery() {
      this.params.OrderProductNo = ''
      this.params.ProductName = ''
      this.params.ShowType = null
      this.params.FinishDateStart = this.$commonJs.getToday()
      this.params.FinishDateEnd = this.$commonJs.getToday()
      this.params.OrderProductNo = ''
      this.params.Status = null
      this.OrderDate = this.$commonJs.getToday()
      this.mode = null

      this.$refs.list.getData()
    },
    getBgStyle(level) {
      let bgStyle = ''
      switch (level) {
        case 0:
          bgStyle = 'rgb(179 204 250)'
          break
        case 1:
          bgStyle = 'rgb(182 255 255)'
          break
        case 2:
          bgStyle = 'rgb(208 182 255)'
          break
        case 3:
          bgStyle = 'rgb(221 255 182)'
          break
        case 4:
          bgStyle = 'rgb(255 215 182)'
          break
        case 5:
          bgStyle = 'rgb(181 203 237)'
          break
        case 6:
          bgStyle = 'rgb(255 182 182)'
          break
        case 7:
          bgStyle = 'rgb(255 231 182)'
          break
        case 8:
          bgStyle = 'rgb(182 255 201)'
          break
      }

      return {
        backgroundColor: bgStyle
      }
    },
    getStage(Stage) {
      if (Stage == 0) {
        Stage =1
      }
      const stage = this.machiningStageList.find(stage => stage.MachiningStageId === Stage)
      return stage ? stage.Name : '未找到加工方式'
    },
    expandChange({ currentRow }) {
      console.log('currentRow', currentRow)
      let OrderProductId = currentRow.OrderProductId
      this.api
        .saOrderProductDisplay({
          ShowType: this.params.ShowType,
          OrderProductId: OrderProductId
        })
        .then(res => {
          if (res.Code === 0) {
            if (this.params.ShowType === 0) {
              let data = JSON.parse(JSON.stringify(res.Data))
              data.forEach(item => {
                item.Level = this.numToText(item.Level)
                item.Stage = this.getStage(item.Stage)
              })
              currentRow.listData = data

              // 根据层数汇总
              let levels = res.Data.map(item => {
                return item.Level
              })

              levels = Array.from(new Set(levels)) // 去重数组

              console.log('levels', levels)

              let obj = {}
              for (let i = 0; i < levels.length; ++i) {
                obj['_' + levels[i]] = []
              }

              let length = res.Data.length

              for (let i = 0; i < levels.length; ++i) {
                for (let j = 0; j < length; ++j) {
                  if (res.Data[j].Level === levels[i]) {
                    obj['_' + res.Data[j].Level].push(res.Data[j])
                  }
                }
              }

              console.log('obj====', obj)

              let arr = []
              for (let key in obj) {
                let level = Number(key.substring(1))
                let levelName = this.numToText(level) + '结构'

                let a = 0 // 入库数总和
                let b = 0 // 生产数总和

                obj[key].forEach(item => {
                  a = a + item.StockInQuantity
                  b = b + item.Quantity
                })

                let sumfinishRate = parseFloat((a / b).toFixed(2))

                if (sumfinishRate > 1) {
                  sumfinishRate = 1
                }
                let notsumfinishRate = parseFloat((1 - sumfinishRate).toFixed(2))

                let sumfinishRateNumber = parseInt(sumfinishRate * 100)

                let sumTenthsNumber = parseInt(sumfinishRateNumber / 10) // 十位
                let sumSingleDigitNumber = sumfinishRateNumber - sumTenthsNumber * 10 // 个位

                let sumSingleDigitNumberWidth = (40 / 10) * sumSingleDigitNumber

                sumfinishRate = parseInt(sumfinishRate * 100) + '%'
                notsumfinishRate = parseInt(notsumfinishRate * 100) + '%'

                let headerData = {
                  sumfinishRate,
                  notsumfinishRate,
                  sumTenthsNumber,
                  sumSingleDigitNumberWidth: {
                    width: sumSingleDigitNumberWidth + 'px'
                  },
                  bgStyle: this.getBgStyle(level)
                }

                obj[key].forEach(item => {
                  let finishRate = parseFloat((item.StockInQuantity / item.Quantity).toFixed(2))

                  if (finishRate > 1) {
                    finishRate = 1
                  }
                  let notFinishRate = parseFloat((1 - finishRate).toFixed(2))

                  let finishRateNumber = parseInt(finishRate * 100)
                  // 总宽度设为300px

                  let tenthsNumber = parseInt(finishRateNumber / 10) // 十位
                  let singleDigitNumber = finishRateNumber - tenthsNumber * 10 // 个位

                  let singleDigitNumberWidth = (35 / 10) * singleDigitNumber

                  finishRate = parseInt(finishRate * 100) + '%'
                  notFinishRate = parseInt(notFinishRate * 100) + '%'

                  item.finishRate = finishRate
                  item.notFinishRate = notFinishRate
                  item.tenthsNumber = tenthsNumber

                  item.singleDigitNumberWidth = {
                    width: singleDigitNumberWidth + 'px'
                  }

                  item.bgStyle = this.getBgStyle(level)
                })

                let o = {
                  levelName,
                  bgStyle: this.getBgStyle(level),
                  headerData,
                  data: obj[key]
                }
                arr.push(o)
              }

              console.log('arr', arr)

              currentRow.imageData = arr
            } else {
              let data = JSON.parse(JSON.stringify(res.Data))
              data.forEach(item => {
                item.Stage = this.getStage(item.Stage)
              })
              currentRow.listData = data

              // 根据层数汇总
              let Stages = res.Data.map(item => {
                return item.Stage
              })

              Stages = Array.from(new Set(Stages)) // 去重数组

              console.log('Stages', Stages)

              let obj = {}
              for (let i = 0; i < Stages.length; ++i) {
                obj['_' + Stages[i]] = []
              }

              let length = res.Data.length

              for (let i = 0; i < Stages.length; ++i) {
                for (let j = 0; j < length; ++j) {
                  if (res.Data[j].Stage === Stages[i]) {
                    obj['_' + res.Data[j].Stage].push(res.Data[j])
                  }
                }
              }

              console.log('obj====', obj)

              let arr = []
              for (let key in obj) {
                let Stage = Number(key.substring(1))
                let levelName = this.getStage(Stage)

                let a = 0 // 入库数总和
                let b = 0 // 生产数总和

                obj[key].forEach(item => {
                  a = a + item.StockInQuantity
                  b = b + item.Quantity
                })

                let sumfinishRate = parseFloat((a / b).toFixed(2))

                if (sumfinishRate > 1) {
                  sumfinishRate = 1
                }
                let notsumfinishRate = parseFloat((1 - sumfinishRate).toFixed(2))

                let sumfinishRateNumber = parseInt(sumfinishRate * 100)

                let sumTenthsNumber = parseInt(sumfinishRateNumber / 10) // 十位
                let sumSingleDigitNumber = sumfinishRateNumber - sumTenthsNumber * 10 // 个位

                let sumSingleDigitNumberWidth = (40 / 10) * sumSingleDigitNumber

                sumfinishRate = parseInt(sumfinishRate * 100) + '%'
                notsumfinishRate = parseInt(notsumfinishRate * 100) + '%'

                let headerData = {
                  sumfinishRate,
                  notsumfinishRate,
                  sumTenthsNumber,
                  sumSingleDigitNumberWidth: {
                    width: sumSingleDigitNumberWidth + 'px'
                  },
                  bgStyle: this.getBgStyle(Stage)
                }

                obj[key].forEach(item => {
                  let finishRate = parseFloat((item.StockInQuantity / item.Quantity).toFixed(2))

                  if (finishRate > 1) {
                    finishRate = 1
                  }
                  let notFinishRate = parseFloat((1 - finishRate).toFixed(2))

                  let finishRateNumber = parseInt(finishRate * 100)
                  // 总宽度设为300px

                  let tenthsNumber = parseInt(finishRateNumber / 10) // 十位
                  let singleDigitNumber = finishRateNumber - tenthsNumber * 10 // 个位

                  let singleDigitNumberWidth = (35 / 10) * singleDigitNumber

                  finishRate = parseInt(finishRate * 100) + '%'
                  notFinishRate = parseInt(notFinishRate * 100) + '%'

                  item.finishRate = finishRate
                  item.notFinishRate = notFinishRate
                  item.tenthsNumber = tenthsNumber

                  item.singleDigitNumberWidth = {
                    width: singleDigitNumberWidth + 'px'
                  }
                  item.bgStyle = this.getBgStyle(Stage)
                })

                let o = {
                  levelName,
                  headerData,
                  bgStyle: this.getBgStyle(Stage),
                  data: obj[key]
                }
                arr.push(o)
              }

              console.log('arr', arr)

              currentRow.imageData = arr
            }
          }
        })
    },
    resetDataFunc(data) {
      data.forEach(item => {
        item.tabsView = 'tabsView1'
        item.listData = []
        item.imageData = []
        console.log('item', item)
      })
      console.log('data', data)
      this.$refs.list.setExpands([])
      return data
    },
    changeMode(val) {
      if (val === 1) {
        // 近三天
        this.params.FinishDateStart = this.$dayjs(this.OrderDate).subtract(2, 'day').format('YYYY-MM-DD')
        this.params.FinishDateEnd = this.OrderDate
      } else if (val === 2) {
        // 近七天
        this.params.FinishDateStart = this.$dayjs(this.OrderDate).subtract(6, 'day').format('YYYY-MM-DD')
        this.params.FinishDateEnd = this.OrderDate
      } else if (val === 3) {
        this.params.FinishDateStart = ''
        this.params.FinishDateEnd = ''
      }
    },
    changeOrderDate(val) {
      if (this.mode == null) {
        // 没选完工范围
        this.params.FinishDateStart = val
        this.params.FinishDateEnd = val
      } else {
        if (this.mode === 1) {
          // 近三天
          this.params.FinishDateStart = this.$dayjs(val).subtract(2, 'day').format('YYYY-MM-DD')
          this.params.FinishDateEnd = val
        } else if (this.mode === 2) {
          // 近七天
          this.params.FinishDateStart = this.$dayjs(val).subtract(6, 'day').format('YYYY-MM-DD')
          this.params.FinishDateEnd = val
        } else if (this.mode === 3) {
          this.params.FinishDateStart = ''
          this.params.FinishDateEnd = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}

.height100 {
  height: 100%;
}

.scroll {
  overflow-x: scroll;
}

.boxwitdh {
  width: 100%;
}

.flex1 {
  flex: 1;
}

.widthx {
  width: 500px;
}

.shrink {
  flex-shrink: 0;
}

.textcenter {
  text-align: center;
  line-height: 40px;
}

.width100px {
  width: 100px;
}

.height {
  height: 40px;
}

.smbox {
  height: 30px;
  width: 35px;
}

.height40 {
  height: 40px;
  line-height: 40px;
}

.text-over {
  overflow: hidden;
  text-overflow: ellipsis;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.align-center {
  align-items: center;
}

.border {
  border: 1px solid #141313;
}

.borderleft {
  border-left: 1px solid #000;
}

.borderright {
  border-right: 1px solid #000;
}

.ml {
  margin-left: 0px;
}

.hidden {
  overflow: hidden;
}

.width30 {
  width: 35px;
}

.width40 {
  width: 40px;
}

.width0 {
  width: 0px;
}

.bgColor {
  background: #ccc;
}

.position-relative {
  position: relative;
}

.position-text {
  position: absolute;
  left: 140px;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}
</style>
